var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbsence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 21C20 21.552 19.551 22 19 22H5C4.449 22 4 21.552 4 21V3C4 2.448 4.449 2 5 2H8V3C8 4.656 9.344 6 11 6H13C14.656 6 16 4.656 16 3V2H19C19.551 2 20 2.448 20 3V21ZM10 2H14V3C14 3.552 13.551 4 13 4H11C10.449 4 10 3.552 10 3V2ZM19 0H5C3.344 0 2 1.344 2 3V21C2 22.656 3.344 24 5 24H19C20.656 24 22 22.656 22 21V3C22 1.344 20.656 0 19 0ZM16 9.5C15.724 9.5 15.474 9.612 15.293 9.793H15.292L10 15.085L8.707 13.793C8.526 13.612 8.276 13.5 8 13.5C7.448 13.5 7 13.948 7 14.5C7 14.776 7.112 15.026 7.293 15.207L9.292 17.207C9.302 17.217 9.316 17.221 9.327 17.23C9.412 17.309 9.507 17.377 9.616 17.422C9.726 17.468 9.845 17.488 9.965 17.493C9.977 17.493 9.987 17.5 10 17.5C10.016 17.5 10.028 17.492 10.043 17.491C10.16 17.486 10.276 17.467 10.383 17.423C10.505 17.372 10.615 17.299 10.707 17.207L16.707 11.207C16.888 11.026 17 10.776 17 10.5C17 9.948 16.552 9.5 16 9.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_1201",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 20,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 21C20 21.552 19.551 22 19 22H5C4.449 22 4 21.552 4 21V3C4 2.448 4.449 2 5 2H8V3C8 4.656 9.344 6 11 6H13C14.656 6 16 4.656 16 3V2H19C19.551 2 20 2.448 20 3V21ZM10 2H14V3C14 3.552 13.551 4 13 4H11C10.449 4 10 3.552 10 3V2ZM19 0H5C3.344 0 2 1.344 2 3V21C2 22.656 3.344 24 5 24H19C20.656 24 22 22.656 22 21V3C22 1.344 20.656 0 19 0ZM16 9.5C15.724 9.5 15.474 9.612 15.293 9.793H15.292L10 15.085L8.707 13.793C8.526 13.612 8.276 13.5 8 13.5C7.448 13.5 7 13.948 7 14.5C7 14.776 7.112 15.026 7.293 15.207L9.292 17.207C9.302 17.217 9.316 17.221 9.327 17.23C9.412 17.309 9.507 17.377 9.616 17.422C9.726 17.468 9.845 17.488 9.965 17.493C9.977 17.493 9.987 17.5 10 17.5C10.016 17.5 10.028 17.492 10.043 17.491C10.16 17.486 10.276 17.467 10.383 17.423C10.505 17.372 10.615 17.299 10.707 17.207L16.707 11.207C16.888 11.026 17 10.776 17 10.5C17 9.948 16.552 9.5 16 9.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_1201)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbsence);
export default __webpack_public_path__ + "static/media/absence.8c4cd2875a5c0b44d31044d4e33c87a1.svg";
export { ForwardRef as ReactComponent };